import instance from './axiosInstance';

export const getPersistence = (params: any, http = instance, options: any = {}) =>
  http.get('/persistence', { params, ...options });

export const deletePersistence = (key: string, http = instance, options: any = {}) => {
  
  return http.delete(`/persistence${key}`, options);
};

export const putPersistence = (payload: any, http = instance) => http.put('/persistence', payload);

export const persistenceStats = (payload: any, http = instance) =>
  http.post('/persistence/stats', payload);

export const persistenceSearch = (payload: any, http = instance) =>
  http.post('/persistence/search', payload);

export const persistenceClear = (payload: any, http = instance) =>
  http.post('/persistence/clear', payload);

export const setCustomerDefaultPersistence = async (config: any, http = instance): Promise<any> => {
  const response = await http.post(`/manage/persistence/customer-default`, config);
  return response.data;
};

export const deleteCustomerDefaultPersistence = async (
  config: any,
  http = instance,
): Promise<any> => {
  const response = await http.delete(`/manage/persistence/customer-default`, {
    data: config,
  });
  return response.data;
};
